import { GenerateLineItemsParams } from '@schuettflix/summary';
import { AutomaticTransportPropertiesSchema } from '@/shared/models/ContextDataModel/interfaces/entities/properties.ts';
import { ProductConfiguration } from '@/shared/models/ContextDataModel/interfaces/entities/product-configuration.ts';

export function toLineItemProductConfigurations(
    productConfigurations: ProductConfiguration[]
): GenerateLineItemsParams['productConfigurations'] {
    return productConfigurations.map(productConfiguration => {
        const parsedTransportProperties = AutomaticTransportPropertiesSchema.safeParse(
            productConfiguration.additionalProperties
        ).data;

        return {
            ...productConfiguration,
            partnerOrganizationId:
                parsedTransportProperties?.processedBy === 'TRANSPORT_EXCHANGE'
                    ? 'TRANSPORT_EXCHANGE'
                    : productConfiguration.partnerOrganizationId!,
            numberOfTransports: parsedTransportProperties?.numberOfTransports,
        };
    });
}
